export async function streamChatResponse(userId: string, query: string, 
  callbacks: {
    onToken: (token: string) => void,
    onComplete: () => void,
    onError: (error: string) => void
  }
) {

  try {
    const response = await fetch('https://ecosystem-api.gaiodataos.com/api/common/chat/message', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ message: query, userId })
    });

    if (!response.ok) {
      throw new Error(`Erro na resposta da API: ${response.status}`);
    }

    const reader = response.body?.getReader();
    if (!reader) {
      throw new Error('Não foi possível obter o leitor de stream.');
    }

    // Processamento do stream
    const decoder = new TextDecoder();
    let buffer = '';

    const processStream = async () => {
      while (true) {
        const { done, value } = await reader.read();
        
        if (done) {
          callbacks.onComplete();
          break;
        }

        // Decodifica o valor e o adiciona ao buffer
        buffer += decoder.decode(value, { stream: true });
        
        // Processa as linhas completas do buffer
        const lines = buffer.split('\n');
        buffer = lines.pop() || ''; // Mantém qualquer linha incompleta no buffer
        
        for (const line of lines) {
          if (!line.trim()) continue;
          
          // Se a linha começa com "data:", processa o JSON dentro dela
          if (line.startsWith('data:')) {
            const jsonStr = line.substring(5).trim();
            if (jsonStr === '[DONE]') {
              callbacks.onComplete();
              return;
            }
            
            try {
              const data = JSON.parse(jsonStr);
              if (data.content) {
                callbacks.onToken(data.content);
              }
            } catch (error) {
              console.error('Erro ao analisar JSON do evento:', error);
            }
          }
        }
      }
    };

    processStream().catch(error => {
      console.error('Erro ao processar stream:', error);
      callbacks.onError('Erro ao processar resposta.');
    });

  } catch (error) {
    console.error('Erro na requisição:', error);
    callbacks.onError('Erro ao processar sua solicitação.');
  }
}
